/**
 * Product Accordion JavaScript
 * Handles single-open accordion behavior and shipping dropdown interaction
 */

document.addEventListener('DOMContentLoaded', function() {
  /**
   * Initialize single-open accordion behavior
   * Only one accordion can be open at a time when enabled
   */
  function initSingleOpenAccordion() {
    const accordionSections = document.querySelectorAll('.product-accordion[data-single-open="true"]');
    
    accordionSections.forEach((section) => {
      const accordionItems = section.querySelectorAll('accordion-custom');
      
      // If single-open is enabled, ensure only the first open accordion stays open
      const openDetails = Array.from(section.querySelectorAll('accordion-custom > details[open]'));
      openDetails.slice(1).forEach((details) => {
        details.removeAttribute('open');
      });
      
      // Set up toggle listeners
      accordionItems.forEach((item) => {
        const details = item.querySelector('details');
        if (!details) return;

        details.addEventListener('toggle', () => {
          if (details.open) {
            // Close all other accordions in this section
            accordionItems.forEach((otherItem) => {
              const otherDetails = otherItem.querySelector('details');
              if (otherDetails && otherDetails !== details) {
                otherDetails.open = false;
              }
            });
          }
        });
      });
    });
  }

  /**
   * Initialize shipping dropdown interaction
   * Shows/hides country-specific shipping information based on selection
   * Uses event delegation to work with dynamically loaded/hidden content
   */
  function initShippingDropdown() {
    // Use event delegation on the document to catch all dropdown changes
    document.addEventListener('change', (e) => {
      // Check if the changed element is a shipping dropdown select
      if (e.target.classList.contains('shipping-dropdown__select')) {
        const select = e.target;
        const dropdown = select.closest('.shipping-dropdown');
        if (!dropdown) return;
        
        const selectedIndex = select.value;
        const contentDivs = dropdown.querySelectorAll('.shipping-dropdown__content');
        
        // Remove disabled class when a country is selected
        if (selectedIndex !== '-1') {
          select.classList.remove('is-disabled');
        } else {
          select.classList.add('is-disabled');
        }
        
        // Hide all content divs
        contentDivs.forEach((content) => {
          content.hidden = true;
        });
        
        // Show the selected country's content
        if (selectedIndex !== '-1') {
          const selectedContent = dropdown.querySelector(`[data-country-index="${selectedIndex}"]`);
          if (selectedContent) {
            selectedContent.hidden = false;
          }
        }
      }
    });
  }

  // Initialize all functionality
  initSingleOpenAccordion();
  initShippingDropdown();
});

